import styled from 'styled-components'

export const PageWrapper = styled.div<any>`
    width: 100%;
    padding: 1rem;
    padding-top: 2rem;
    ${props => props.maxWidth && 'max-width: ' + props.maxWidth + ';'}
    max-width: 1000px;
    ${props => props.centered && 'margin: 0 auto;'}
`